import { createFileRoute } from "@tanstack/react-router";
import { listNewsletterIssues } from "@/lib/newsletter-public.functions";
import { InlineNewsletter } from "@/components/InlineNewsletter";
import { pageTitle } from "@/lib/brand";
import { PageIntro, PageSection, LinkRows, MoreLink, type RowItem } from "@/components/site/page";

const CANONICAL = "https://akillisurdurulebilirlik.com/bulten";
const DESC =
  "Akıllı Sürdürülebilirlik bülteninin herkese açık arşivi: yapay zeka, iklim ve insan geleceği üzerine haftalık notlar. Tüm sayıları okuyun.";

export const Route = createFileRoute("/bulten/")({
  loader: async () => {
    const { issues } = await listNewsletterIssues().catch(() => ({ issues: [] }));
    return { issues };
  },
  head: () => ({
    meta: [
      { title: pageTitle("Bülten Arşivi", "tr") },
      { name: "description", content: DESC },
      { property: "og:title", content: "Bülten Arşivi — Akıllı Sürdürülebilirlik" },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: CANONICAL },
    ],
    links: [
      { rel: "canonical", href: CANONICAL },
    ],
  }),
  errorComponent: () => (
    <div className="mx-auto max-w-2xl px-5 py-20 text-center">
      <p className="text-theme-tech">Bülten arşivi yüklenemedi.</p>
    </div>
  ),
  component: ArchivePage,
});

function fmt(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString("tr-TR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

function ArchivePage() {
  const { issues } = Route.useLoaderData();

  const items: RowItem[] = issues.map((issue, i) => ({
    key: issue.slug,
    to: "/bulten/$slug",
    params: { slug: issue.slug },
    title: issue.subject,
    meta: `${String(issues.length - i).padStart(2, "0")} · ${fmt(issue.sent_at)}`,
  }));

  return (
    <>
      <PageIntro
        crumbs={[{ label: "Bülten" }]}
        kicker="Arşiv"
        title="Akıllı Sürdürülebilirlik Bülteni"
        lede="Yapay zeka, iklim ve insan geleceği üzerine haftalık notlar. Geçmiş sayıların tamamı burada açık; okumak için abone olmanız gerekmiyor."
      />
      <PageSection>
        <InlineNewsletter />
      </PageSection>
      <PageSection>
        {issues.length === 0 ? (
          <p className="border-y border-ink/10 py-10 text-ink/70">Henüz yayımlanmış bir sayı yok.</p>
        ) : (
          <LinkRows items={items} withExcerpt={false} />
        )}
        <div className="mt-8">
          <MoreLink href="/rss.xml">RSS</MoreLink>
        </div>
      </PageSection>
    </>
  );
}
